import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getPreferredLocale, localePath } from './publicPaths';

/** Redirige /programmes/:slug → /{locale}/programmes/:slug, etc. */
const LegacyPublicRedirect = ({ template }) => {
  const params = useParams();
  const path = template.replace(/:(\w+)/g, (_, key) => {
    const value = params[key] ?? '';
    if (key === 'slug' && value === 'imaar') return 'ramadan';
    if (key === 'slug' && value === 'ihyaa') return 'adahi';
    return value;
  });
  return <Navigate to={localePath(path, getPreferredLocale())} replace />;
};

export default LegacyPublicRedirect;
